var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-wrap"},[_c('div',{staticClass:"title"},[_vm._v("Scan code to download app")]),_c('img',{attrs:{"src":_vm.QRImgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }